import { h, defineComponent, VNode } from 'vue';

export interface IconProps {
  icon: string|VNode;
  iconPack?: 'far' | 'fas' | 'fal';
  classes?: string;
  size?: 'lg' | 'xs' | 'sm' | '1x' | '2x' | '3x' | '4x' | '5x' | '6x' | '7x' | '8x' | '9x' | '10x';
  rotation?: number | null;
}

export const iconProps = {
  icon: { type: [String, Object], required: true },
  classes: { type: String },
  rotation: { type: Number },
  size: { type: String },
  iconPack: { type: String },
};

export const Icon = defineComponent<IconProps>({
  name: 'Icon',
  props: iconProps,
  setup(props, context) {
    const onClick = () => context.emit('click');

    return function render(): VNode {
      if (typeof props.icon !== 'string') {
        return h('i', {
          class: props.classes ? props.classes : '',
          on: { click: onClick },
        }, [props.icon]);
      }

      return h('font-awesome-icon', {
        class: props.classes ? props.classes : '',
        props: {
          rotation: props.rotation ? props.rotation : null,
          size: props.size,
          icon: [
            props.iconPack ?? 'far',
            props.icon,
          ],
        },
        on: { click: onClick },
      }, []);
    };
  },
});
